import { HorseVariantIcon } from './HorseVariantIcon';

/**
 * author: Colton Wiscombe
 * id 359CB8BA-79AF-43F7-AE85-562432388C2E
 * name horse-variant
 * version: 5.6.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/horse-variant.svg
 * tags
 * - Animal 
 * - Agriculture 
 */
export const EquestrianVariantIcon = HorseVariantIcon;
export default EquestrianVariantIcon